/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionnaireEvaluateRequestAnswer } from './QuestionnaireEvaluateRequestAnswer';
import {
    QuestionnaireEvaluateRequestAnswerFromJSON,
    QuestionnaireEvaluateRequestAnswerFromJSONTyped,
    QuestionnaireEvaluateRequestAnswerToJSON,
    QuestionnaireEvaluateRequestAnswerToJSONTyped,
} from './QuestionnaireEvaluateRequestAnswer';

/**
 * 
 * @export
 * @interface QuestionnaireEvaluateRequestAnswers
 */
export interface QuestionnaireEvaluateRequestAnswers {
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    rejected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    isNewContract: boolean;
    /**
     * 
     * @type {Array<QuestionnaireEvaluateRequestAnswer>}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    userAnswers: Array<QuestionnaireEvaluateRequestAnswer>;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    sustainabilityId: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    contractId: string;
}

/**
 * Check if a given object implements the QuestionnaireEvaluateRequestAnswers interface.
 */
export function instanceOfQuestionnaireEvaluateRequestAnswers(value: object): value is QuestionnaireEvaluateRequestAnswers {
    if (!('rejected' in value) || value['rejected'] === undefined) return false;
    if (!('isNewContract' in value) || value['isNewContract'] === undefined) return false;
    if (!('userAnswers' in value) || value['userAnswers'] === undefined) return false;
    if (!('sustainabilityId' in value) || value['sustainabilityId'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    return true;
}

export function QuestionnaireEvaluateRequestAnswersFromJSON(json: any): QuestionnaireEvaluateRequestAnswers {
    return QuestionnaireEvaluateRequestAnswersFromJSONTyped(json, false);
}

export function QuestionnaireEvaluateRequestAnswersFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireEvaluateRequestAnswers {
    if (json == null) {
        return json;
    }
    return {
        
        'rejected': json['rejected'],
        'isNewContract': json['isNewContract'],
        'userAnswers': ((json['userAnswers'] as Array<any>).map(QuestionnaireEvaluateRequestAnswerFromJSON)),
        'sustainabilityId': json['sustainabilityId'],
        'contractId': json['contractId'],
    };
}

export function QuestionnaireEvaluateRequestAnswersToJSON(json: any): QuestionnaireEvaluateRequestAnswers {
    return QuestionnaireEvaluateRequestAnswersToJSONTyped(json, false);
}

export function QuestionnaireEvaluateRequestAnswersToJSONTyped(value?: QuestionnaireEvaluateRequestAnswers | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rejected': value['rejected'],
        'isNewContract': value['isNewContract'],
        'userAnswers': ((value['userAnswers'] as Array<any>).map(QuestionnaireEvaluateRequestAnswerToJSON)),
        'sustainabilityId': value['sustainabilityId'],
        'contractId': value['contractId'],
    };
}

